var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.0625C3.5 16.4823 3.73047 15.9259 4.1407 15.5157C4.55094 15.1055 5.10734 14.875 5.6875 14.875H17.5",
    stroke: "#9E9E9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 1.75H17.5V19.25H5.6875C5.10734 19.25 4.55094 19.0195 4.1407 18.6093C3.73047 18.1991 3.5 17.6427 3.5 17.0625V3.9375C3.5 3.35734 3.73047 2.80094 4.1407 2.3907C4.55094 1.98047 5.10734 1.75 5.6875 1.75V1.75Z",
    stroke: "#9E9E9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryIcon);
export default __webpack_public_path__ + "static/media/library_icon.2fd45f8a10a776f7007e3000ea312da7.svg";
export { ForwardRef as ReactComponent };